import type { UserDto } from "@/dto";

/**
 * Identify a user in the tracking system
 * @param user the user to identify
 */
export function identifyUser(user: UserDto) {
  window.pb?.identify({
    id: user.id,
    email: user.email,
    first_name: user.first_name,
    last_name: user.last_name,
    company: user.company,
    source_app: "skore-hub",
  });
}
